export default __webpack_public_path__ + "static/media/121.97f37ec9.png";